import { Typography } from "@mui/material";
import { fPercent } from "src/utils/formatNumber";

import { Position } from "../hooks/useGetPositionRows";

export default function SectionWeight({ weight }: Position) {
	return <Typography variant='subtitle2'>{fPercent(weight)}</Typography>;
}
